<template>
    <div v-if="isFullscreen"
         class="fullscreen-overlay"
         @click="toggleFullscreen">
    </div>


    <div :class="['fullscreen-wrapper', { fullscreen: isFullscreen }]">
        <div class="d-flex justify-content-between align-items-center"
           :style="{
                    padding: isFullscreen ? '.5rem' : '.1rem',
                    marginBottom: isFullscreen ? '5px' : '0',
                    backgroundColor: isFullscreen ? 'grey' : 'white',
                    position: isFullscreen ? 'sticky' : 'static',
                    zIndex: isFullscreen ? '99999' : '0',
                    top: isFullscreen ? '-20px' : null}">
        <h6 class="mb-0" :style="{color: isFullscreen ? 'white' : 'inherit'}">{{ title }}</h6>

        <button class="btn btn-sm" :class="{'btn-outline-primary' : !isFullscreen}" @click="toggleFullscreen">
          <template v-if="isFullscreen">
            <div style="position:sticky; top:0">
              <i class="bi bi-fullscreen-exit me-2"></i>
              <span>Wyjdź z trybu pełnego ekranu</span>
            </div>
          </template>
          <template v-else>
            <div>
              <i class="bi bi-fullscreen me-2 mb-2"></i>
              <span>Pełny ekran</span>
            </div>
          </template>
        </button>
      </div>
	  
    <table class="table table-bordered">
      <tbody>
      <tr>
        <th>Nr pozycji:</th>
        <td>{{ selectedRecord.id }}</td>

        <th>Zespół:</th>
        <td>{{ selectedRecord.team_name }}</td>

        <th>Podzespół nr rysunku</th>
        <td>{{ selectedRecord.subteam_drawing_no }}</td>
      </tr>
      <tr>
        <th>Nr katalogowy</th>
        <td>{{ selectedRecord.article?.catalog_number || '' }}</td>

        <th>Model</th>
        <td>{{ selectedRecord.article?.model || '' }}</td>

        <th>Opis</th>
        <td>{{ selectedRecord.article?.description || '' }}</td>
      </tr>
      <tr>
        <th>link</th>
        <td>{{ selectedRecord.link }}</td>

        <th>J.m.</th>
        <td>{{ selectedRecord.article_unit?.name }}</td>

        <th>Producent</th>
        <td>{{ selectedRecord.producer?.id }}</td>
      </tr>
      <tr>
        <th>Kategoria</th>
        <td>{{ selectedRecord.customer_category?.id }}</td>

        <th>Ilość wymagana</th>
        <td>{{ selectedRecord.quantity_required }}</td>

        <th>Dostawcy</th>
        <td>{{ selectedRecord.suppliers_short_names }}</td>
      </tr>
      <tr>
        <th>Dodany przez</th>
        <td>{{ selectedRecord.created_by?.name }}</td>

        <th>Data dodania</th>
        <td>{{ formatDate(selectedRecord.created_at) }}</td>

        <th>Status</th>
        <td>{{ selectedRecord.status }}</td>
      </tr>
      <tr>
        <th>Data dostawy</th>
        <td>{{ formatDate(selectedRecord.delivery_date) }}</td>

        <th>Data zwolnienia</th>
        <td>{{ formatDate(selectedRecord.release_date) }}</td>

        <th>Data zlec. zamówienia</th>
        <td>{{ formatDate(selectedRecord.order_submission_date) }}</td>
      </tr>
      <tr>
        <th>Data Wydr. zamówienia</th>
        <td>{{ formatDate(selectedRecord.order_status_confirmation_date) }}</td>

        <th>Status magazynowy</th>
        <td>{{ selectedRecord.inventory_status }}</td>

        <th>Data produkcji</th>
        <td>{{ formatDate(selectedRecord.production_due_date) }}</td>
      </tr>
      <tr>
        <th>Czas dowstawy</th>
        <td>{{ formatDate(selectedRecord.lead_time) }}</td>

        <th>Uwagi</th>
        <td>{{ selectedRecord.comments }}</td>

        <th>Ostatnio zmienił</th>
        <td>{{ selectedRecord.updated_by?.name }}</td>
      </tr>
      <tr>
        <th>Ilość magazynowa</th>
        <td>{{ selectedRecord.article_main_warehouse?.quantity }}</td>

        <th>Magazyn</th>
        <td>{{ selectedRecord.warehouse_received }}</td>

        <th>Nr Patentu</th>
        <td>{{ selectedRecord.patent_number }}</td>
      </tr>
      <tr>
        <th>Ilość do zamówienia</th>
        <td>{{ (selectedRecord.numbering?.quantity || 0) * (selectedRecord.quantity_required || 0) }}</td>
      </tr>


      </tbody>
    </table>
  </div>
</template>

<script>
import {Modal} from "bootstrap";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";

let dropInstanceFilterUnits, delivererElem, multiSelectObj;

export default {
  components: {
    "ejs-datepicker": DatePickerComponent,
  },

  props: {
    selectedRecord: Object,
    statuses: Object
  },

  data() {
    return {
	isFullscreen: false
	}
  },

  methods: {
      toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;

      // opcjonalnie blokada scrolla dokumentu
      document.body.style.overflow = this.isFullscreen ? 'hidden' : '';
    },
    formatDate(dateString) {
      if (!dateString)
        return '';

      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są od 0 do 11, więc dodajemy 1
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },
  }
}

</script>

<style scoped>

th {
  max-width: 50px;
}

/* Główny wrapper komponentu */
.fullscreen-wrapper {
  position: relative;
  transition: all .3s ease-in-out;
}

/* Tryb pełnoekranowy */
.fullscreen-wrapper.fullscreen {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 20px;
  background: #ffffff;
  overflow: auto;
  box-shadow: 0 0 40px rgba(0,0,0,.25);
  animation: fadeInFullscreen .2s ease-in-out;
}

/* Przyciemnione tło */
.fullscreen-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1049;
}

/* Delikatna animacja wejścia */
@keyframes fadeInFullscreen {
  from {
    opacity: 0;
    transform: scale(.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

</style>